import Vue from 'vue';
import DecorationSlider from '@/components/DecorationSlider/DecorationSlider.vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { JSONParser } from '@/utils/JSONParser';
import { DecorationSliderProps } from '@/components/DecorationSlider/types';

export function createDecorationSliderWidget(el: Element) {
    if(!el) return;
    const rootAttrs = new RootElementAttrsHolder(el);
    const parser = new JSONParser('decorationSliderJson');

    const decorationSliderAttr = el.getAttribute('data-options');

    const props: DecorationSliderProps = {
        decorationSliderStat: parser.parse(decorationSliderAttr)
    };

    return new Vue({
        el,
        name: 'DecorationSlider',
        rootAttrs,
        render(h) {
            return h(DecorationSlider, { props });
        },
    });
}
